// extracted by mini-css-extract-plugin
export default {"button":"button_button__AhkMh","primary":"button_primary__k1g5g","secondary":"button_secondary__iQ5Z5"};